
import { Component } from '@angular/core';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';
import { SimulatorConfig } from '../../../core/models/simulation.model';
import { BasicSimulatorComponent } from '../../../common/basic-simulator/basic-simulator.component';

@Component({
  selector: 'app-formation-factor',
  imports: [BasicSimulatorComponent],
  standalone: true,
  templateUrl: './formation-factor.component.html',
  styleUrl: './formation-factor.component.scss',
})
export class FormationFactorComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Formation Factor Simulation',
    simulatorType: SimulatorType.SubsampleFF,
  };
}
